import AnimatedSection from '../../../components/base/AnimatedSection';

export default function Features() {
  const features = [
    {
      icon: 'ri-mic-line',
      title: 'Professional Quality',
      description:
        'Studio-grade production with industry-standard equipment and techniques for pristine sound quality.',
    },
    {
      icon: 'ri-time-line',
      title: 'Fast Delivery',
      description:
        'Get your licensed beats instantly after purchase. Custom sessions delivered within 48 hours.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secure Licensing',
      description:
        'Full legal protection with comprehensive licensing agreements for commercial use and distribution.',
    },
    {
      icon: 'ri-headphone-line',
      title: 'Unlimited Revisions',
      description:
        'Available on Premium projects only — work with us until it\'s perfect. Your satisfaction is guaranteed with unlimited revision rounds.',
    },
  ];

  return (
    <section className="py-14 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <AnimatedSection animation="fade-up" className="text-center mb-10 md:mb-16">
          <div className="inline-block px-4 py-2 border border-gray-300 rounded-full text-xs font-semibold text-gray-700 mb-3 md:mb-4">
            WHAT YOU GET
          </div>
          <h2 className="text-3xl md:text-6xl font-bold text-gray-900 mb-3 md:mb-4 leading-tight">
            Professional Quality,<br />
            Fast Delivery
          </h2>
          <p className="text-sm md:text-lg text-gray-600 max-w-2xl mx-auto">
            Everything you need to create chart-topping music
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <AnimatedSection
              key={index}
              animation="fade-up"
              delay={index * 120}
              className="bg-white p-5 md:p-8 rounded-2xl hover:shadow-xl transition-all duration-300 group cursor-pointer hover:bg-gradient-to-br hover:from-red-600 hover:to-red-800"
            >
              <div className="w-12 h-12 md:w-16 md:h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4 md:mb-6 group-hover:bg-white/20 transition-colors">
                <i
                  className={`${feature.icon} text-2xl md:text-3xl text-gray-700 group-hover:text-white`}
                ></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3 group-hover:text-white transition-colors">
                {feature.title}
              </h3>
              <p className="text-xs md:text-base text-gray-600 leading-relaxed group-hover:text-white/90 transition-colors">
                {feature.description}
              </p>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
